import React, { Component } from "react";
import { Dispatch } from "redux";
import { connect } from "react-redux";
import { TokenGroup } from "@amzn/awsui-components-react/polaris";
import constants from "../../../../config/constants";
import { desenseCombineKeyHandler } from "./desense-combine-util";
import { setUserRequestForm } from "../../../../redux/actions/request-form-action";

interface StateProps {
  requestFormReducer: any;
}

type Props = { dispatch: Dispatch<any> } & StateProps;

const defaultProps = Object.freeze({});
const initialState = Object.freeze({
  tokenItem: [],
  requestItem: [],
});

class DesenseCombineKeys extends Component<Props> {
  static readonly defaultProps = defaultProps;
  readonly state = initialState;

  onTokenDismiss = ({ detail: { itemIndex } }) => {
    const tokenList = [...this.state.tokenItem];
    const formatList = [...this.state.requestItem];
    if (itemIndex > -1) {
      tokenList.splice(itemIndex, 1);
      formatList.splice(itemIndex, 1);
    }
    this.setState({ tokenItem: tokenList, requestItem: formatList }, () => {
      this._setDesenseCombineKeyToReducer();
    });
  };

  _setDesenseCombineKeyToReducer = () => {
    const { userSelectForm } = this.props.requestFormReducer;
    let updateSelected = { ...userSelectForm };
    const { requestItem } = this.state;
    updateSelected[constants.REQUEST_FORM_TEST_PLAN_KEY][
      constants.TEST_CATEGORY_KEY_DESENSE
    ] = requestItem;
    this.props.dispatch(setUserRequestForm(updateSelected));
  };

  _formatStateItems = () => {
    const { userSelectForm } = this.props.requestFormReducer;
    // Calc combinations based on multi-select
    const formatItems = desenseCombineKeyHandler(
      userSelectForm[constants.REQUEST_FORM_TEST_PLAN_KEY]
    );

    const tokenItem =
      formatItems !== undefined
        ? formatItems.map((each) => {
            return { label: each, id: each };
          })
        : ([] as any);
    this.setState({ tokenItem: tokenItem, requestItem: formatItems }, () => {
      this._setDesenseCombineKeyToReducer();
    });
  };

  componentDidUpdate(prevProps) {
    const { userSelectForm } = this.props.requestFormReducer;
    if (
      userSelectForm[constants.REQUEST_FORM_TEST_PLAN_KEY] !==
      prevProps.requestFormReducer.userSelectForm[
        constants.REQUEST_FORM_TEST_PLAN_KEY
      ]
    ) {
      this._formatStateItems();
    }
  }

  render() {
    const { tokenItem } = this.state;
    return (
      <div>
        <div>Desense combine keys:</div>
        <div>
          <TokenGroup onDismiss={this.onTokenDismiss} items={tokenItem} />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    requestFormReducer: state.requestFormReducer,
  };
};

export default connect<StateProps>(mapStateToProps)(DesenseCombineKeys);
